import { render, staticRenderFns } from "./delegataire.vue?vue&type=template&id=45a2a1d2&scoped=true"
import script from "./delegataire.vue?vue&type=script&lang=js"
export * from "./delegataire.vue?vue&type=script&lang=js"
import style0 from "./delegataire.vue?vue&type=style&index=0&id=45a2a1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2a1d2",
  null
  
)

export default component.exports